import { ErrorService, LoaderService, NotificationService, CONSTANT, LOADPAGE, GridDataSource } from '../session/index';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material';
import { OfficeService } from '../../../app/modules/security/office/shared/office.service';
import { AplicacionService } from 'src/app/modules/security/Aplicaciones/shared/aplicacion.service';
import { Aplicacion } from 'src/app/modules/security/Aplicaciones/shared/aplicacion.model';
import { Office } from 'src/app/modules/security/office/shared/office.model';
import { ModuleService } from 'src/app/modules/security/modules/shared/module.service';
import { Module } from 'src/app/modules/security/modules/shared/module.model';

@Component({
	//moduleId: module.id,
	selector: 'app-sectionbar',
	templateUrl: 'sectionbar.component.html'
})

export class SectionBarComponent implements OnInit {
	@Output() onSearchEmit: EventEmitter<any> = new EventEmitter();
	@Output() onProcessEmit: EventEmitter<any> = new EventEmitter();
	@Input() titlePage: string;
	@Input() totalCount: number;
	@Input() indSearch: boolean;
	@Input() dataAuditoria: any;

	@Input() indCboOffice: boolean;
	@Input() indCboModule: boolean;
	@Input() indCboAplicacion: boolean;
	@Output() filtro: string;
	@Output() aplicacionID: number;
	@Output() officeID: number;
	@Output() moduleID: number;


	msgErrorGetAplicaciones: string = "";
	msgErrorGetOficce: string = "";

	aplicaciones: Aplicacion[];
	offices: Office[];
	modules: Module[];

	classWisthAutoFocus: string = "";
	classCloseButton: string;
	indLoad: boolean = false;
	classClose: string = "mib-close";
	classCloseBlock: string = "mib-close block";
	classFullWidth: string = "full-width";
	classSubtitleAnchor: string = "col-md-4";
	classClear: string = "";
	dataSource: GridDataSource;
	pageSize: number = CONSTANT.pageSize;
	pageEvent: PageEvent;
	indHidden: boolean;
	originalTotalCount: number;
	indLoadPage: number;

	constructor(private errorService: ErrorService, private notificationService: NotificationService, private loaderService: LoaderService,
		private officeService: OfficeService, private moduleService: ModuleService,
		private aplicacionService: AplicacionService
	) { }

	ngOnInit(): void {
		this.msgErrorGetAplicaciones = "Ocurrió un error al obtener las aplicaciones";
		this.msgErrorGetOficce = "Ocurrió un error al obtener las oficinas";

		this.aplicacionID = CONSTANT.aplicacionIDDefault;
		this.officeID = CONSTANT.officeIDDefault;
		this.moduleID = CONSTANT.ModuleIDDefault;
		this.classCloseButton = this.classClose;
		this.indLoadPage = LOADPAGE.firstLoad;
		this.filtro = this.classClear;
		this.indHidden = false;
	}

	ngAfterViewChecked() {
		if (!(this.indLoad)) {
			if (this.indCboAplicacion)
				this.listarAplicacionCbo();
			if (this.indCboModule)
				this.listarModuleCbo();
			if (this.indCboOffice)
				this.listarOfficeCbo();
			if (this.indCboAplicacion || this.indCboOffice)
				this.classSubtitleAnchor = "col-md-4";
			this.search();
			this.indLoad = true;
		}
	}

	search() {
		if (this.indLoad)
			this.setIndHidden();

		switch (true) {
			case this.indCboModule:
				this.onSearchEmit.emit({ filtro: this.filtro, aplicacionID: this.aplicacionID, moduleID: this.moduleID });
				break;
			case this.indCboOffice:
				this.onSearchEmit.emit({ filtro: this.filtro, officeID: this.officeID });
				break;
			case this.indCboAplicacion:
				this.onSearchEmit.emit({ filtro: this.filtro, aplicacionID: this.aplicacionID });
				break;
			case this.indSearch:
				this.onSearchEmit.emit({ filtro: this.filtro });
				break;
			default:
				break;
		}
	}

	clearTotalCount() {
		this.originalTotalCount = 0;
		this.indLoadPage = LOADPAGE.firstLoad;
	}

	setIndHidden() {
		if (!this.originalTotalCount || (this.originalTotalCount < this.totalCount))
			this.originalTotalCount = this.totalCount;
	}

	onKeyUpSearch() {
		if (this.filtro.length > CONSTANT.cantCaracteres)
			this.classCloseButton = this.classCloseBlock;
		else
			this.classCloseButton = this.classClose;
	}

	focusSearch() {
		this.classWisthAutoFocus = this.classFullWidth;
	}

	onCloseButton() {
		this.filtro = this.classClear;
		this.classCloseButton = this.classClose;
		this.classWisthAutoFocus = this.classClear;
		this.indLoadPage = LOADPAGE.postback;
		this.search();
	}

	blurSearch() {
		if (!(this.filtro.length > 0))
			this.classWisthAutoFocus = this.classClear;
	}

	onSearch() {
		this.indLoadPage = LOADPAGE.postback;
		this.search();
	}

	onChangeCboAplicaciones(event: any) {
		this.clearTotalCount();
		this.listarModuleCbo();
		// this.search();
	}

	onChangeCboModules(event: any) {
		this.clearTotalCount();
		this.search();
	}


	private listarAplicacionCbo(): void {
		this.loaderService.show();
		this.aplicacionService.listarApplication()
			.subscribe(res => {
				this.aplicaciones = res;
			},
				error => {
					this.notificationService.error(this.msgErrorGetAplicaciones);
					throw error;
				},
				() => {
					this.loaderService.hide();
				});
	}

	private listarOfficeCbo(): void {
		this.loaderService.show();
		this.officeService.listarOffice('', 0, 0, true)
			.subscribe(res => {
				this.offices = res;
				this.officeID = this.offices[0].ID
			},
				error => {
					this.notificationService.error(this.msgErrorGetOficce);
					throw error;
				},
				() => {
					this.loaderService.hide();
				});
	}

	private listarModuleCbo(): void {
		this.loaderService.show();
		this.moduleService.listarPorModulos('', this.aplicacionID, 0, 0)
			.subscribe(res => {
				this.modules = res;
				this.moduleID = res[0].ModuleID
				this.search()
			},
				error => {
					this.notificationService.error(this.msgErrorGetAplicaciones);
					throw error;
				},
				() => {
					this.loaderService.hide();
				});
	}
}
